<template>
  <a-page-header class="page-header" @back="back">
    <div slot="title" class="flex-align-center" style="cursor: pointer" @click="back">
      <div style="margin-right: 10px; font-size: 17px">返回</div>
      <div v-for="(item, index) in dataSource" :key="index" style="font-size: 17px">
        <span
          :style="{
            color: index === dataSource.length - 1 ? '#297EDE' : '#262626',
          }"
        >
          {{ item.label }}
        </span>
        <span v-if="dataSource.length - 1 !== index" style="margin: 0 5px">/</span>
      </div>
    </div>
  </a-page-header>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props: {
    dataSource: {
      type: Array,
      default: () => [
        // {
        //   label: '数据概览页',
        //   path: '/',
        //  isBack:true
        // },
        // {
        //   label: '上周末未采集',
        //   path: '/school/workbench',
        // },
      ],
    },
  },
  methods: {
    // handleBack(item) {
    //   console.log('点击面包屑：', item)
    //   // 路径跳转
    //   if (item?.path) {
    //     this.$router.push(item.path)
    //     return
    //   }
    //   // 返回
    //   if (item?.isBack) {
    //     this.$router.go(-1)
    //   }
    // },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 10px 20px;
}
</style>
